import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import whitelogo from "../../assets/images/header/logo.svg";

const LoginHeader = (props) => {
  return (
    <Fragment>
      <div className="login_logo margin-bottom-30 text-center">
        <Link className="logo-link" to="/" title="Home Page">
          <img alt="alldaydr logo" src={whitelogo} height="53" ></img>
        </Link>
      </div>
      <div className="login_title margin-bottom-30 text-center">
        <h1 className="font-26 weight-600 text-white margin-0">
          eVideo and eTherapy with ADDVantage Minds
        </h1>
      </div>
    </Fragment>
  );
};

export default LoginHeader;
